// extracted by mini-css-extract-plugin
export default {"pageWrap":"vc-z","fullWidth":"wc-z","heading":"xc-z","fullBleed":"yc-z","hidden":"zc-z"};